export const AccountStatus = {
  INACTIVE: 0,
  ACTIVE: 1,
  SUBMITTED: 2,
  PENDING_VERIFICATION: 3,
  LOCKED: 4,
  PASSWORD_EXPIRED: 5,
  REJECTED: 6,
} as const;

export type AccountStatusId = (typeof AccountStatus)[keyof typeof AccountStatus];

export const AccountStatusLabel: Record<number, string> = {
  [AccountStatus.INACTIVE]: 'Inactive',
  [AccountStatus.ACTIVE]: 'Active',
  [AccountStatus.SUBMITTED]: 'Submitted',
  [AccountStatus.PENDING_VERIFICATION]: 'Pending verification',
  [AccountStatus.LOCKED]: 'Locked',
  [AccountStatus.PASSWORD_EXPIRED]: 'Password expired',
  [AccountStatus.REJECTED]: 'Rejected',
};

export const canEditUserStatus = (status: number | string | null | undefined): boolean => {
  const normalizedStatus = Number(status);
  if (!Number.isFinite(normalizedStatus)) return false;

  const editableStatuses: number[] = [
    AccountStatus.ACTIVE,
    AccountStatus.INACTIVE,
    AccountStatus.SUBMITTED,
  ];

  return editableStatuses.includes(normalizedStatus);
};

export const isReadOnlyUserStatus = (status: number | string | null | undefined): boolean => {
  const normalizedStatus = Number(status);
  if (!Number.isFinite(normalizedStatus)) return true;

  const readOnlyStatuses: number[] = [
    AccountStatus.PENDING_VERIFICATION,
    AccountStatus.LOCKED,
    AccountStatus.PASSWORD_EXPIRED,
    AccountStatus.REJECTED,
  ];

  return readOnlyStatuses.includes(normalizedStatus) || !canEditUserStatus(normalizedStatus);
};
